
import popular_01 from '../assets/images/popular-01.jpg'
import popular_02 from '../assets/images/popular-02.jpg'
import popular_03 from '../assets/images/popular-03.jpg'
import popular_04 from '../assets/images/popular-04.jpg'
import popular_05 from '../assets/images/popular-05.jpg'
import popular_06 from '../assets/images/popular-06.jpg'
import popular_07 from '../assets/images/popular-07.jpg'
import popular_08 from '../assets/images/popular-08.jpg'


const MostPop = [
    {id :'most_popular_item_0',img:popular_01,title:'Forntair',category: 'sandbox' ,rate:'3.6',download:'1.1'},
  
    {id :'most_popular_item_1',img:popular_02,title:'pupG',category: 'sandbox' ,rate:'3.7',download:'3.5'},
  
    {id :'most_popular_item_2',img:popular_03,title:'Dota2',category: 'sandbox' ,rate:'4.5',download:'6.3'},
  
    {id :'most_popular_item_3',img:popular_04,title:'CS-Go',category: 'sandbox' ,rate:'3.6',download:'5.4'},
  
    {id :'most_popular_item_4',img:popular_05,title:'Forntair',category: 'sandbox' ,rate:'2.2',download:'2.1'},
  
    {id :'most_popular_item_5',img:popular_06,title:'pupG',category: 'sandbox' ,rate:'2.4',download:'1.3'},
  
    {id :'most_popular_item_6',img:popular_07,title:'Dota2',category: 'sandbox' ,rate:'3.6',download:'1.1'},
  
    {id :'most_popular_item_7',img:popular_08,title:'CS-Go',category: 'sandbox' ,rate:'2.7',download:'1.1'},
  
  
  ]

  export default MostPop